<template>
  <div v-if="isFullSize" class="bg-white">
    <div class="d-flex" style="">
      <div class="d-flex flex-column flex-fill">
        <div class="d-flex p-1">
          <span class="text-nowrap" style="width:120px;">フォーム</span>
          <el-select placeholder=""
            class="flex-fill"
            v-if="viewModel && viewModel.inspectMasterList"
            v-model="searchCondition.inspectMasterId"
            size="small"
            clearable
            >
            <el-option v-for="item in viewModel.inspectMasterList"
                      class="select-primary"
                      :value="item.inspectMaster.id"
                      :label="item.inspectMaster.name"
                      :key="item.inspectMaster.name">
            </el-option>
          </el-select>
        </div>
        <div class="d-flex p-1">
          <span class="text-nowrap" style="width:90px;">ステータス</span>
          <el-select
            class="flex-fill"
            placeholder=""
            v-if="viewModel && viewModel.iconSettingList"
            size="small"
            v-model="searchCondition.iconId"
            clearable
            >
            <el-option v-for="icon in viewModel.iconSettingList"
                      class="select-primary"
                      :value="icon.masterId + '-' + icon.iconSetting.id"
                      :label="icon.iconSetting.name"
                      :key="icon.iconSetting.name">
                      <img class="statusIcon" :src="iconKeyToPath[`${icon.masterId}-${icon.iconSetting.id}`]" /><span class="ml-1">{{icon.iconSetting.name}}</span>
            </el-option>
            <template #prefix>
              <img class="statusIcon" v-if="searchCondition.iconId" :src="iconKeyToPath[searchCondition.iconId]" />
            </template>
          </el-select>
        </div>
      </div>

      <div class="d-flex flex-column flex-fill">
          <div class="d-flex p-1 pb-2">
            <div class="text-nowrap " style="width:120px;min-width:120px;">作成日</div>
            <el-date-picker
              v-model="searchCondition.createDate"
              type="date"
              size="small"
              class="inline-input flex-fill"
              placeholder="作成日を選択"
              :shortcuts="[{text: '今日', value: new Date()}]"
            />
          </div>

          <div class="d-flex p-1 pb-2">
            <div class="text-nowrap " style="width:120px;min-width:120px;">作成者</div>
            <el-input
              class="inline-input flex-fill"
              size="small"
              v-model="searchCondition.createUser"
              placeholder="作成者を入力"
              clearable
            ></el-input>
          </div>

          <div class="d-flex p-1 pb-2">
            <div class="text-nowrap " style="width:120px;min-width:120px;">更新日</div>
            <el-date-picker
              v-model="searchCondition.updateDate"
              type="date"
              size="small"
              class="inline-input flex-fill"
              placeholder="更新日を選択"
              :shortcuts="[{text: '今日', value: new Date()}]"
            />
          </div>

          <div class="d-flex p-1 pb-2">
            <div class="text-nowrap " style="width:120px;min-width:120px;">更新者</div>
            <el-input
              class="inline-input flex-fill"
              size="small"
              v-model="searchCondition.updateUser"
              placeholder="更新者を入力"
              clearable
            ></el-input>
          </div>
          </div>

      <!-- ▽検索項目変更カスタマイズ -->
      <div class="d-flex flex-column flex-fill searchCondition" style="overflow:auto;" v-if="viewSearchCondition">
          <div class="d-flex p-1 pb-1"
            v-for="(addedSearchCondition, index) in addedSearchConditions"
            :key="index"
            >
            <div class="d-flex pr-1" style="width:120px;min-width:120px;">
              <el-select
                class=""
                placeholder=""
                size="small"
                v-model="addedSearchConditions[index].joinId"
                @change="onChangeSearchItem(addedSearchConditions[index].joinId, index)"
                >
                <el-option v-for="item in searchFormsItemList"
                  class="select-primary"
                          :value="item.joinId"
                          :label="item.name"
                          :key="item.joinId"
                          :disabled="item.disabled">
                          </el-option>
              </el-select>
            </div>

            <div class="d-flex flex-fill pr-1" style="width:120px;min-width:120px;" v-if="addedSearchConditions[index].itemType == '1'">
                <el-input
                  class="inline-input flex-fill"
                  size="small"
                  v-model="addedSearchConditions[index].value"
                  placeholder="入力"
                  clearable
                ></el-input>
            </div>

            <div class="d-flex flex-fill pr-1" style="width:120px;min-width:120px;" v-if="addedSearchConditions[index].itemType == '3'">
              <el-date-picker
                class="inline-input flex-fill"
                size="small"
                type="daterange"
                unlink-panels
                v-model="addedSearchConditions[index].dateValues"
                start-placeholder="開始日"
                end-placeholder="終了日"
                :shortcuts="datePickerShortcuts"
                clearable
              />
            </div>

            <div class="d-flex flex-fill  pr-1" style="width:120px;min-width:120px;" v-if="addedSearchConditions[index].itemType == '4'">
              <el-select
                class="inline-input flex-fill"
                placeholder=""
                size="small"
                v-model="addedSearchConditions[index].value"
                filterable
                clearable>
                <el-option v-for="item in getInputList(addedSearchConditions[index].joinId)"
                          class="select-primary"
                          :value="item.id"
                          :label="item.name"
                          :key="item.id">
                </el-option>
              </el-select>
            </div>

            <el-button icon="el-icon-delete" size="small" @click="deleteSearchRow(index)" class="border-primary text-white bg-primary" circle ></el-button>
          </div>
      </div>
      <!-- △検索項目変更カスタマイズ -->
    </div>

    <div class="d-flex justify-content-center">
      <base-button
        outline
        type="primary"
        @click="clearCondition"
      >
        <span class="btn-inner--icon"
          ><i class="fas fa-search"></i>
          </span>
        <span class="btn-inner--text">条件クリア</span>
      </base-button>

      <base-button
        outline
        type="primary"

        @click="searchList"
      >
        <span class="btn-inner--icon"
          ><i class="fas fa-search"></i>
          </span>
        <span class="btn-inner--text">検索</span>
      </base-button>

      <!-- ▽検索項目変更カスタマイズ -->
      <!-- ボタン活性時 -->
      <base-button
          v-if="isCustomized == true && addedSearchConditions.length < this.searchFormsItemList.length"
          outline
          type="primary"

          @click="addCondition"
        >
          <span class="btn-inner--icon"
            ><i class="fas fa-plus"></i>
            </span>
          <span class="btn-inner--text">検索条件追加</span>
        </base-button>

        <!-- ボタン非活性時 -->
        <base-button
          v-if="isCustomized == true && addedSearchConditions.length >= this.searchFormsItemList.length"
          disabled
          outline
          type="default"

          @click="addCondition"
        >
          <span class="btn-inner--icon"
            ><i class="fas fa-plus"></i>
            </span>
          <span class="btn-inner--text">検索条件追加</span>
        </base-button>
        <!-- △検索項目変更カスタマイズ -->
    </div>
  </div>
  <div class="bg-white">
    <div class="card-header border-0" v-if="true">
      <div class="row pt-0 pb-0 pl-2 pr-3 no-gutters">
        <!-- 検査箇所一覧(検索結果) -->
        <div class="row">
          <table-tool-menu
            :title="`${title} ${selectedData.length > 0 ? '(' + selectedData.length + ' / ' + maxSelect + '件選択)' : ``}`"
            :isAdd="placeListOnly"
            :isEdit="false"
            :isCopy="false"
            :isDelete="false"
            :isExport="isExport"
            :exportTitle="'CSV出力'"
            :isSingleSelect="isSingleSelect"
            :isMultiSelect="isMultiSelect"
            :processing="processing"
            @addNew="onClickNewPlace"
            @export="onClickOutput"
            @delete="onClickDelete"
          >
          </table-tool-menu>
        </div>
        <!-- カスタマイズレコードが存在する場合のみ表示 -->
        <div v-if="isCustomized == true && !isExport" class="customized-count">
            <!--表示件数/合計件数  -->
            {{displayedCount}} / {{total}}
        </div>
        <!-- <div class="col-lg-4">
          <div class="mt-1 d-flex justify-content-center">
            <el-pagination
              @current-change="setCurrent"
              :page-size="pagination.perPage"
              :current-page="pagination.currentPage"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div> -->
        <!-- <div class="col-lg-4">
        </div> -->
      </div>
    </div>
    <el-table
      v-if="viewModel && viewModel.inspectMasterList"
      class="table-responsive align-items-center table-flush pl-2"
      cell-class-name="pt-0 pb-0"
      header-row-class-name="thead-light"
      ref="inspectPlaceListTable"
      empty-text="検査箇所がありません"
      @select="handleSelect"
      @selection-change="handleSelectionChange"
      @sort-change="runSort"
      :default-sort="{ prop: 'name', order: 'descending' }"
      :cell-style="{height: '20px'}"
      :row-key="getRowKey"
      :data="pagedData">
        <el-table-column type="selection" align="left" min-width="200px" :reserve-selection="true">
        </el-table-column>
        <el-table-column label="フォーム" min-width="200px" prop="textValue" sortable="'custom'" v-if="viewInspectMaster">
            <template v-slot="{ row }">
            <b>
              <a class="text-nowrap" href="#!" @click.prevent="onPushMap(row)"
                >{{ viewModel.inspectMasterNameById[row.inspectPlace.inspectMasterId] }}
              </a>
            </b>
          </template>
        </el-table-column>
        <el-table-column label="ステータス" min-width="90px" prop="iconClass" >
          <template v-slot="{ row }">
            <img :src="iconKeyToPath[`${row.inspectPlace.inspectMasterId}-${row.inspectPlace.iconId}`]" class="bg-white avatar mr-3" v-if="iconKeyToPath[`${row.inspectPlace.inspectMasterId}-${row.inspectPlace.iconId}`]" style="display:inline-block;" />
          </template>
        </el-table-column>
        <el-table-column label="検査箇所名" min-width="300px" prop="name">
            <template v-slot="{ row }">
                <template v-if="!viewInspectMaster">
                    <a class="text-nowrap" href="#!" @click.prevent="onPushMap(row)">{{row.inspectPlace.name}}
                    </a>
                </template>
                <template v-else>
                    <span class="text-truncate">{{row.inspectPlace.name}}</span>
                </template>
            </template>
        </el-table-column>

        <!-- 追加検索列 -->
        <el-table-column
            v-if="inspectPlaces.length > 0 && viewInspectPlaces && isCustomized === true && viewAdditionalResults"
            v-for="(inspectPlace, index) in afterSearchConditions.additionalConditions"
            :key="index"
            :label="inspectPlace.name"
            min-width="200px">
            <template v-slot="{ row }">
                <span class="text-truncate" v-if="row.inspectResult?.inspectList?.[index]?.itemType === '1'">
                    {{ row.inspectResult.inspectList[index].value }}
                </span>
                <span class="text-truncate" v-if="row.inspectResult?.inspectList?.[index]?.itemType === '3'">
                  {{ row.inspectResult.inspectList[index].value ? dateStringFormat(row.inspectResult.inspectList[index].value) : '' }}
                </span>
                <span class="text-truncate" v-if="row.inspectResult?.inspectList?.[index]?.itemType === '4'">
                    {{ getInput(row.inspectPlace.inspectMasterId,row.inspectResult.inspectList[index]) }}
                </span>
            </template>
        </el-table-column>

        <template v-if="inspectPlaces.length === 0 && !viewInspectPlaces && isCustomized === true && viewAdditionalResults">
            <el-table-column v-for="(afterSearchCondition, conditionIndex) in afterSearchConditions.additionalConditions"
                :key="conditionIndex" :label="afterSearchCondition.name" min-width="200px">
                <template v-slot="scope">
                    <span class="text-truncate">{{ afterSearchCondition.value }}</span>
                </template>
            </el-table-column>
        </template>

        <el-table-column label="作成日時" min-width="130px" prop="createdAt" v-if="viewCreatedAt">
          <template v-slot="{ row }">
            <span class="text-truncate">{{dateStringFormat(row.createdAt)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="作成者" min-width="200px" prop="createUser" v-if="viewCreatedUser">
          <template v-slot="{ row }">
            <span class="text-truncate">{{viewModel.userDictionary[row.createdUser]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新日時" min-width="130px" prop="updatedAt" v-if="viewUpdatedAt">
          <template v-slot="{ row }">
            <span class="text-truncate">{{dateStringFormat(row.updatedAt)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新者" min-width="200px" prop="updatedUser" v-if="viewUpdatedUser">
          <template v-slot="{ row }">
            <span class="text-truncate">{{viewModel.userDictionary[row.updatedUser]}}</span>
          </template>
        </el-table-column>
      </el-table>
    <div class="row mt-1">
      <div class="col">
        <div class="mt-1 d-flex justify-content-center">
          <el-pagination
            @current-change="setCurrent"
            :page-size="pagination.perPage"
            :current-page="pagination.currentPage"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

  <modal v-model:show="formOutputShow" size="lg" body-classes="p-0" style="z-index:1060;" >
    <formOutput v-if="formOutputShow" @cancel="cancelForm" @makeForm="makeForm" :selectedList="selectedData" ref="formOutput" ></formOutput>
  </modal>
  <!-- 確認用モーダル -->
  <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1052 !important;" body-classes="p-0">
    <confirm-modal
      :title="confirm.title"
      :message="confirm.message"
      :leftButtonLabel="confirm.leftButtonLabel"
      :rightButtonLabel="confirm.rightButtonLabel"
      @onClickLeftButton="onClickConfirmLeft"
      @onClickRightButton="onClickConfirmRight"
      />
  </modal>
</template>
<style scoped>
.subContent {
  border-radius: 0.25rem !important;
  background-color: white;
  margin: 5px;
  padding: 5px;
  font-size: 0.9em;
}

.vertical-separator {
    border-left: 1.5px solid lightgray;
    height: 100%;
    margin: 2px 0px 0px 0px;
    padding: 0px px 0px 0px;
}

/* 追加検索行横にスクロールバーを表示させるために指定 */
.searchCondition {
  height: 168px;
}
/* 件数集計機能のための指定 */
.customized-count {
  margin: 0.25rem 0 0;
  margin-left: 1.5rem;
  font-size: 15px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  color: #32325d;
}

</style>

<script>

import { Storage } from "aws-amplify";
import InspectMasterModel from "../../appModel/InspectMaster/InspectMasterModel";
import InspectPlaceModel from "../../appModel/InspectPlace/InspectPlaceModel";
import CsvInfoModel from "../../appModel/CsvInfo/CsvInfoModel";
import UserInfo from '../../appUtils/UserInfo';
import FormOutput from '@/appViews/Form/FormOutput'
import TableToolMenu from "../components/Menu/TableToolMenu"
import Modal from "@/components/Modal";
import DateUtil from '../../appUtils/DateUtil'
import { useToast } from "vue-toastification";
import constants from "@/Config/constants"
import FileUtil from "@/appUtils/FileUtil"
import TenantStorage from "@/appUtils/TenantStorage"
import InspectPlaceListViewModel from "@/appViews/InspectPlace/ViewModel/InspectPlaceListViewModel"
import s3Util from "@/awsUtil/s3Util";
import path from "path";
import InspectPlaceViewModel from "@/appViews/InspectPlace/ViewModel/InspectPlaceViewModel"
import SortUtil from "@/appUtils/SortUtil"
import CustomizeUtil from "../../appUtils/CustomizeUtil";
import CustomizeModel from "../../appModel/Customize/CustomizeModel";

export default {
  /**
   * コンポーネント
   */
  components: {
    FormOutput,
    Modal,
    TableToolMenu
  },
  /**
   * プロパティ
   */
  props: {
    /**
     * プロジェクトID
     */
    projectId: {
      type: String,
      default: "",
    },
    /**
     * ノードID
     */
    nodeId: {
      type: String,
      default: "",
    },
    /**
     * ノード種別(backimage / map)
     */
    nodeType: {
      type: String,
      default: "",
    },
    isFullSize: {
      type: Boolean,
      default: true
    },
    placeListOnly: {
      type: Boolean,
      default: false
    }
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    //インスタンスが生成され､且つデータが初期化された後
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
    if (!this.sortColumn.prop) {
      // 初期ソート
      this.sortColumn = {prop: `name`, order: `descending`}
    }
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init()
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    this.inspectMasters = null
    this.inspectPlaces = null
    //Vue インスタンスが破壊された後
  },
  data() {
    return {
      inspectMasters: [],
      inspectPlaces: [],
      inspectPlacesAll: [],
      inspectResults: [],
      iconUrlList: {},
      iconClassNameList: {},
      searchCondition: {
        createUser: "",
        createDate: "",
        updateUser: "",
        updateDate: "",
        inspectMasterId: "",
        iconId: ""
      },
      suggestions: {
        inspectPlaceNumber: [],
        inspectPlaceName: [],
        lineName: [],
        createUser: [],
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      sortColumn: {},
      selectedData: [],
      formOutputShow: false,
      modal: {
        isShow: false,
        title: "",
        message: "",
        okLabel: "OK",
        okType: "secondary",
        okCallBack: function() {
          alert(`push Ok`)
          this.modal.isShow = false
        },
        cancelLabel: "キャンセル",
        cancelType: "primary",
        cancelCallBack: function() {
          alert(`push cancel`)
          this.modal.isShow = false
        },
      },
      confirm: {
        title: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      showConfirm: false,
      title: "検査箇所一覧",
      isExport: true,
      isSingleSelect: false,
      isMultiSelect: false,
      tenantId: null,
      tenantStorage: null,

      viewModel: null,
      // systemIconFileList: [
      //   {"type": "1", "name": "青丸", "key": constants.iconpath.icon1, "path": "blank" },
      //   {"type": "2", "name": "緑丸", "key": constants.iconpath.icon2, "path": "blank" },
      //   {"type": "3", "name": "灰丸", "key": constants.iconpath.icon3, "path": "blank" },
      //   {"type": "4", "name": "赤丸", "key": constants.iconpath.icon4, "path": "blank" },
      //   {"type": "5", "name": "黄丸", "key": constants.iconpath.icon5, "path": "blank" },
      //   {"type": "6", "name": "青星", "key": constants.iconpath.icon6, "path": "blank" },
      //   {"type": "7", "name": "緑星", "key": constants.iconpath.icon7, "path": "blank" },
      //   {"type": "8", "name": "灰星", "key": constants.iconpath.icon8, "path": "blank" },
      //   {"type": "9", "name": "赤星", "key": constants.iconpath.icon9, "path": "blank" },
      //   {"type": "10", "name": "黄星", "key": constants.iconpath.icon10, "path": "blank" },
      //   {"type": "11", "name": "青三角", "key": constants.iconpath.icon11, "path": "blank" },
      //   {"type": "12", "name": "緑三角", "key": constants.iconpath.icon12, "path": "blank" },
      //   {"type": "13", "name": "灰三角", "key": constants.iconpath.icon13, "path": "blank" },
      //   {"type": "14", "name": "赤三角", "key": constants.iconpath.icon14, "path": "blank" },
      //   {"type": "15", "name": "黄三角", "key": constants.iconpath.icon15, "path": "blank" },
      // ],
      // systemIconFileList: constants.sumigomuicon,
      iconKeyToPath: {},
      maxSelect: 50,
      isCustomized: false,
      viewSearchCondition: false,
      addedSearchConditions: [],
      afterSearchConditions: {
        additionalConditions: []
      },
      searchFormsItemList: [],
      selectedIndex: "",
      viewInspectMaster: true,
      viewCreatedAt: true,
      viewCreatedUser: true,
      viewUpdatedAt: true,
      viewUpdatedUser: true,
      viewInspectPlaces: false,
      viewAdditionalResults: false,
      datePickerShortcuts: [],
    };
  },
  watch: {
    /**
     * 検索項目の変更を監視
     */
    watchJoinId: {
      // オブジェクトのプロパティの変更時に変更を検知するため、deep: trueを設定
      // しかしdeep: trueを設定すると、oldValue・newValueが同じ値になってしまう
      // computedで非参照のコピーを作り、そのcomputedをwatchする
      deep: true,
      handler(newValue, oldValue) {
        // 検索項目の非活性化・活性化
        if (oldValue.length == 0) {
          this.disableSerchItem()
        }
        else if (0 < oldValue.length && this.selectedIndex !== "") {
          this.enableSerchItem(oldValue[this.selectedIndex].joinId)
          this.disableSerchItem()

          let oldValueItemType = oldValue[this.selectedIndex].itemType
          let newValueItemType = newValue[this.selectedIndex].itemType
          if (oldValueItemType !== newValueItemType || newValueItemType == '4') {
            this.addedSearchConditions[this.selectedIndex].value = ""
            this.addedSearchConditions[this.selectedIndex].dateValues = []
          }

          this.selectedIndex = ""
        }
      }
    }
  },
  /**
   * コンピュートプロパティ
   */
  computed: {
    /***
     * ページング用のデータをかえす
     */
    pagedData() {
      return this.inspectPlaces.slice(this.from, this.to)
    },
    /**
     * ページング制御用
     */
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    /**
     * ページング制御用
     */
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    /**
     * ページング制御用
     * (合計件数)
     */
    total() {
      return this.inspectPlaces.length;
    },
    /**
     * 表示件数
     */
    displayedCount(){
      this.totalCount= this.total;

      // 合計件数が10件未満の場合、表示件数は合計件数を設定する
      if (this.totalCount < 10) {
        return this.totalCount;
      } else {
        // 合計件数が10以上の場合、表示件数に現在のページ番号×10の値を設定
        let displayedCount = this.pagination.currentPage * 10;

        //　表示件数が合計件数を超える場合、合計件数を表示件数とする
        if (displayedCount > this.totalCount) {
          return this.totalCount;
        }
        return displayedCount
      }
    },
    /**
     * 検索項目の変更監視用
     */
    watchJoinId () {
      // 非参照のコピーを作る
      return JSON.parse(JSON.stringify(this.addedSearchConditions))
    }
    // /**
    //  * 検査マスタ
    //  */
    // inspectMaster(masterId) {
    //   if (this.inspectMasters) {
    //     for (let i = 0; i < this.inspectMasters.length; i++) {
    //       if (this.inspectMasters[i].id == masterId) {
    //         return this.inspectMasters[i].inspectMaster
    //       }
    //     }
    //   }
    //   return []
    // },
    // /**
    //  * 検査マスタのアイコン
    //  */
    // iconSettingList() {
    //   if (this.inspectMaster(masterId)) {
    //     if (this.inspectMaster(masterId).iconSetting) {
    //       return this.inspectMaster(masterId).iconSetting
    //     }
    //   }
    //   return []
    // },
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    /**
     * ページ変更時のハンドラ
     */
    setCurrent(newPage) {
      this.pagination.currentPage = newPage
    },
    getRowKey(row){
      return row.sk
    },

    async init() {

      let loader = this.showLoader();
      try {
        const tenantStore = this.$store.state.tenant
        this.tenantId = tenantStore.id
        this.tenantStorage = new TenantStorage(this.tenantId)

        this.viewModel = new InspectPlaceListViewModel(this.tenantId, this.projectId, this.nodeId)
        await this.viewModel.init()

        this.inspectPlaces = this.viewModel.filterList
        // カスタマイズレコードを取得する
        let customizeRecord = await CustomizeUtil.checkCustomizeRecords(this.tenantId);

        // カスタマイズレコードキーが住ゴムの場合true
        if (customizeRecord.key === CustomizeUtil.customizeSumigomu) {
          this.isCustomized = true;
          this.isExport = false;
        }

        // アイコンをS3から取得
        const s3 = new s3Util()
        const iconList = this.viewModel.iconSettingList
        for (let i = 0;i < iconList.length;i++) {
          const id = iconList[i].iconSetting.id
          const key = iconList[i].iconSetting.iconFilePath
          const url = await s3.getUrl(iconList[i].iconSetting.iconFilePath)
          const index = `${iconList[i].masterId}-${id}`

          this.iconKeyToPath[index] = url
          // console.log(`id ${id} key: ${key} url: ${url}`)
          console.log(`init: ${index}`)
        }

        if (this.isCustomized == true) {
          // フォーム項目を検索項目リストに格納
          this.setSearchFormsItemList()

          // 日付範囲指定のショートカットを設定
          this.setShortcuts()

          // localStrageに検索条件が保存されている場合、画面表示に反映する
          let searchConditions = await this.getSearchCondition()
          if (searchConditions != null) {
            this.searchCondition = searchConditions.searchCondition
            if (0 < searchConditions.addedSearchConditions.length) {
              this.addedSearchConditions = searchConditions.addedSearchConditions
              this.viewSearchCondition = true
            }
          }
        }
        // カスタマイズレコード挿入メソッド
        // await this.addCustomize();
      } finally {
        this.hideLoader(loader)
      }

    },

    /**
     * サジェスト表示用のデータを初期化する
     */
    async initSuggestions() {
      // 検査箇所No
      let numberDic = {}
      // 検査箇所名
      let nameDic = {}
      // 通り芯名
      let lineNameDic = {}
      // 作成者
      let createUserDic = {}

      // 検査箇所データの値からサジェスト表示用の値を取得
      this.inspectPlaces.forEach(function(item) {
        numberDic[item.inspectPlace.textValue] = item.inspectPlace.textValue
        nameDic[item.inspectPlace.name] = item.inspectPlace.name
        lineNameDic[item.inspectPlace.lineName] = item.inspectPlace.lineName
        createUserDic[item.inspectPlace.createUser] = item.inspectPlace.createUser
      }.bind(this))

      this.suggestions.inspectPlaceNumber = []
      this.suggestions.inspectPlaceName = []
      this.suggestions.lineName = []
      this.suggestions.createUser = []

      // Element-UI用のデータ形式に変換
      Object.keys(numberDic).forEach(value => {
        this.suggestions.inspectPlaceNumber.push({ "value": value, "link": "" })
      })
      Object.keys(nameDic).forEach(value => {
        this.suggestions.inspectPlaceName.push({ "value": value, "link": "" })
      })
      Object.keys(lineNameDic).forEach(value => {
        this.suggestions.lineName.push({ "value": value, "link": "" })
      })
      Object.keys(createUserDic).forEach(value => {
        this.suggestions.createUser.push({ "value": value, "link": "" })
      })
    },

    /**
     * 検索ボタンのイベントハンドラ
     */
    async searchList() {
      let loader = this.showLoader();
      try {
        if (this.isCustomized === true) {
          // 検索ボタンを押下時に検索条件をローカルストレージに保存
          await this.saveSearchCondition(this.searchCondition, this.addedSearchConditions);
        }
        // テーブル選択状態をクリア
        this.clearSelect()

        //  カスタマイズレコードキーが住ゴム(true)の場合
        if (this.isCustomized === true) {
          // 追加検索条件がある場合
          if (this.addedSearchConditions.length > 0) {
            // 検索条件と追加検索条件で検索を行う
            this.inspectPlaces = await this.viewModel.setAdditionalFilter(this.searchCondition, this.addedSearchConditions);
            this.inspectPlaces = await SortUtil.sort(this.inspectPlaces, "inspectPlace.name", "ascending", true);

            this.viewInspectPlaces = false;
            // inspectPlace.inspectResultが存在する場合true
            this.inspectPlaces.forEach(inspectPlace => {
              if (inspectPlace.inspectResult) {
                this.viewInspectPlaces = true;
              }
            });

            // 追加検索条件が無い場合
          } else {
            // 検索条件でフィルターする
            await this.viewModel.setFilter(this.searchCondition)
            this.inspectPlaces = this.viewModel.filterList
            this.inspectPlaces = await SortUtil.sort(this.inspectPlaces, "inspectPlace.name", "ascending", true);
          }
          // 検索条件クリアを押下するとfalseになる
          // 追加検索条件で検索を行った場合true
          this.viewAdditionalResults = true
          //　検索に使用した追加検索条件
          this.afterSearchConditions = {
            additionalConditions: this.addedSearchConditions.map(condition => ({
              joinId: condition.joinId,
              name: condition.name,
              itemType: condition.itemType,
              value: condition.value,
              dateValues: condition.dateValues,
            })),
          };
          // console.log("☆検索に使用した追加検索条件:", this.afterSearchConditions);
          // 検査箇所一覧表示を制御
          this.controllTableDisplay()

          // カスタマイズレコードが設定されていない場合
        } else {
          // 検索条件でフィルターする
          await this.viewModel.setFilter(this.searchCondition)
          this.inspectPlaces = this.viewModel.filterList
          this.inspectPlaces = await SortUtil.sort(this.inspectPlaces, "inspectPlace.name", "ascending", true);
        }
      } finally {
        this.hideLoader(loader)
      }
    },
    async reload() {
      let loader = this.showLoader();
      try {
        // テーブル選択状態をクリア
        this.clearSelect()
        await this.viewModel.init()
        await this.viewModel.setFilter(this.searchCondition)
        this.inspectPlaces = this.viewModel.filterList
      } finally {
        this.hideLoader(loader)
      }
    },
    async clearCondition() {
      this.searchCondition = {
        createUser: "",
        createDate: "",
        updateUser: "",
        updateDate: "",
        inspectMasterId: "",
        iconId: ""
      }

      // 追加検索値のクリア
      if (this.isCustomized == true) {
        this.addedSearchConditions.forEach(addedSearchCondition => {
          addedSearchCondition.value = ""
          addedSearchCondition.dateValues = []
        });

        // 検査箇所一覧表示を制御
        this.viewInspectMaster = true
        this.viewCreatedAt = true
        this.viewCreatedUser = true
        this.viewUpdatedAt = true
        this.viewUpdatedUser = true
        this.viewAdditionalResults = false
      }

      this.viewModel.setFilter(this.searchCondition)
      this.inspectPlaces = this.viewModel.filterList
      this.inspectPlaces = await SortUtil.sort(this.inspectPlaces, "inspectPlace.name", "ascending", true);
    },
    /**
     * 検索条件追加ボタンのイベントハンドラ
     */
    async addCondition() {
      // 初期値設定
      let defaultJoinId = ""
      let defaultItemType = ""
      if (this.addedSearchConditions.length == 0) {
        // 1行目：検索項目リストの1番目
        this.viewSearchCondition = true
        defaultJoinId = this.searchFormsItemList[0].joinId
        defaultItemType = this.searchFormsItemList[0].itemType
      }
      else {
        // 2行目以降：検索項目リスト内で選択可能な項目の1番目
        for (let i = 0; i < this.searchFormsItemList.length; i++) {
          if (this.searchFormsItemList[i].disabled == false) {
            defaultJoinId = this.searchFormsItemList[i].joinId
            defaultItemType = this.searchFormsItemList[i].itemType
            break
          }
        }
      }

      this.addedSearchConditions.push({
        inspectMasterId: "",
        inspectSettingItemId: "",
        joinId: defaultJoinId,
        name: "",
        itemType: defaultItemType,
        value: "",
        dateValues: []
      })

      // 選択された検索項目の非活性化
      this.disableSerchItem()

      // 選択された検索項目の情報をリストに格納
      this.setSearchItemInfo(defaultJoinId, this.addedSearchConditions.length - 1)
    },
    /**
     * 検索行削除ボタンのイベントハンドラ
     * @param {*} index 削除する検索行のインデックス
     */
    async deleteSearchRow(index) {
      this.enableSerchItem(this.addedSearchConditions[index].joinId)
      this.addedSearchConditions.splice(index, 1)
      if (this.addedSearchConditions.length == 0) {
        this.viewSearchCondition = false
      }
    },

    /**
     * 指定した値をローカルストレージに保存します。
     * @param {*} searchCondition デフォルト検索条件
     * @param {*} addedSearchConditions 追加検索条件
     */
    async saveSearchCondition(searchCondition, addedSearchConditions) {
      const key = await this.getSearchConditionStorageKey();
      const item = {
        searchCondition: searchCondition,
        addedSearchConditions: addedSearchConditions
      };
      // オブジェクトをJSONに書き換え
      const itemToSave = JSON.stringify(item);
      localStorage.setItem(key, itemToSave);
    },

    /**
     * ローカルストレージから指定した値を取得します。
     * @returns 保存した検索条件
     */
     async getSearchCondition() {
      const key = await this.getSearchConditionStorageKey();
      // JSONをオブジェクトに変換
      const itemToLoad = localStorage.getItem(key)
      return JSON.parse(itemToLoad);
    },
    /**
     * 検索条件のローカルストレージのキー取得
     * @returns ローカルストレージのキー
     */
    async getSearchConditionStorageKey() {
      let inspectMasterIds = "";
      let inspectMasterIdList = [];

      // 紐づくフォームのIDを取得
      this.viewModel.inspectMasterList.forEach(inspectMasterInfo => {
        inspectMasterIdList.push(inspectMasterInfo.inspectMaster.id)
      })

      // フォームIDの昇順でソート
      inspectMasterIdList.sort()

      // 並び替えたフォームIDをアンダーバーで連結
      inspectMasterIds = inspectMasterIdList.join("_");

      const user = await UserInfo.getUserInfo();
      const loginUserId = user.sub;

      const prefix = `searchCondition`;
      return `${prefix}#${inspectMasterIds}#${loginUserId}`;
    },
    /**
     *フォーム項目を検索項目リストに格納
     */
    setSearchFormsItemList() {
      let inspectMasterId = ""
      this.viewModel.inspectMasterList.forEach(inspectMasterInfo => {
        // フォームID
        inspectMasterId = inspectMasterInfo.inspectMaster.id

        inspectMasterInfo.inspectMaster.inspectItemList.forEach(inspectItem => {
          if (inspectItem.itemType == '1' || inspectItem.itemType == '3' || inspectItem.itemType == '4') {
            // フォーム項目定義IDは重複する可能性がある。フォームIDとフォーム項目定義IDをアンダーバーで結合し、一意の値となる結合IDを作成する
            let joinId = inspectMasterId + '_' + inspectItem.id
            inspectItem.inspectMasterId = inspectMasterId
            inspectItem.joinId = joinId
            inspectItem.disabled = false
            this.searchFormsItemList.push(inspectItem)
          }
        });
      });
    },
    /**
     *リスト型の検索項目の選択肢を取得
     * @param {*} joinId 結合ID（フォームID_フォーム項目定義ID）
     * @returns リスト型検索項目の選択肢
     */
    getInputList(joinId) {
      try {
        console.log(`getInputList ${joinId}`)

        if (!joinId) {
          return []
        }

        if (this.searchFormsItemList) {
          const searchItem = this.searchFormsItemList.filter(function (searchItem) {
            return searchItem.joinId == joinId
          }.bind(this))[0]

          console.log(`getInputList ${JSON.stringify(searchItem.items)}`)

          return searchItem.items
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        throw e
      }
    },
    /**
     * 検索項目の選択肢を取得
     */
    getInput(inspectMasterId, condition) {
      // フォームIDとフォーム項目定義IDでリスト型の検索項目の選択肢を取得
      const joinId = inspectMasterId + '_' + condition.itemId
      const inputList = this.getInputList(joinId);

      // 検索条件のvalueIdに一致する選択肢をフィルタリング
      const inputItem = inputList.filter(function (inputItem) {
        return inputItem.id == condition.valueId
      }.bind(this))[0]

      // 一致する項目があればnameを返す
      return inputItem.name;
    },
    /**
     * 検索項目変更時のイベント
     * @param {*} selectedJoinId 新しく選択された検索項目の結合ID（フォームID_フォーム項目定義ID）
     * @param {*} index 検索項目を変更する検索行のインデックス
     */
    onChangeSearchItem(selectedJoinId, index) {
      this.selectedIndex = index
      this.setSearchItemInfo(selectedJoinId, index)
    },
    /**
     * 検索処理のため検索項目の情報を追加検索条件リストに格納
     * @param {*} selectedJoinId 格納する検索項目の結合ID（フォームID_フォーム項目定義ID）
     * @param {*} index 情報を格納する検索行のインデックス
     */
    setSearchItemInfo(joinId, index) {
      const searchItem = this.searchFormsItemList.filter(function (searchItem) {
        return searchItem.joinId == joinId
      }.bind(this))[0]

      this.addedSearchConditions[index].inspectMasterId = searchItem.inspectMasterId
      this.addedSearchConditions[index].inspectSettingItemId = searchItem.id
      this.addedSearchConditions[index].name = searchItem.name
      this.addedSearchConditions[index].itemType = searchItem.itemType
    },
    /**
     * 検索項目を非活性にする
     */
    disableSerchItem() {
      this.addedSearchConditions.forEach(addedSearchCondition => {
        const searchItem = this.searchFormsItemList.filter(function (searchItem) {
          return searchItem.joinId == addedSearchCondition.joinId
        }.bind(this))[0]

        searchItem.disabled = true
      });
    },
    /**
     * 検索項目を活性にする
     * @param {*} selectedJoinId 活性化する検索項目の結合ID（フォームID_フォーム項目定義ID）
     */
    enableSerchItem(enableJoinId) {
      const searchItem = this.searchFormsItemList.filter(function (searchItem) {
        return searchItem.joinId == enableJoinId
      }.bind(this))[0]

      searchItem.disabled = false
    },
    /**
     * 検査箇所一覧の表示を制御する
     */
    controllTableDisplay() {
      this.viewInspectMaster = (this.searchCondition.inspectMasterId == "" || this.searchCondition.inspectMasterId == null) ? false : true
      this.viewCreatedAt = (this.searchCondition.createDate == "" || this.searchCondition.createDate == null) ? false : true
      this.viewCreatedUser = (this.searchCondition.createUser == "" || this.searchCondition.createUser == null) ? false : true
      this.viewUpdatedAt = (this.searchCondition.updateDate == "" || this.searchCondition.updateDate == null) ? false : true
      this.viewUpdatedUser = (this.searchCondition.updateUser == "" || this.searchCondition.updateUser == null) ? false : true
    },
    /**
     * 日付範囲指定のショートカットを設定する
     */
    setShortcuts() {
      this.datePickerShortcuts = [
        {
          text: '今日',
          value: new Date()
        },
        {
          text: '過去3か月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 3)
            return [start, end]
          },
        },
        {
          text: '過去6か月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            return [start, end]
          },
        },
        {
          text: '過去1年',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setFullYear(start.getFullYear() - 1)
            return [start, end]
          },
        },
      ]
    },
    /**
     * テーブルの選択状態をクリアする
     */
    clearSelect() {
      this.$refs.inspectPlaceListTable.clearSelection()
      this.selectedData = []
    },
    /**
     * 入力候補探索（検査箇所No)
     */
    placeNumberSearch(queryString, cb) {
      if (this.suggestions.inspectPlaceNumber.length == 0) {
        cb()
      }
      if (!queryString) {
        cb(this.suggestions.inspectPlaceNumber)
      }

      let results = this.suggestions.inspectPlaceNumber.filter(item => {
        return item.value.indexOf(queryString) >= 0
      })

      cb(results);
    },
    /**
     * 入力候補探索（検査箇所名)
     */
    placeNameSearch(queryString, cb){
      if (this.suggestions.inspectPlaceName.length == 0) {
        cb()
      }
      if (!queryString) {
        cb(this.suggestions.inspectPlaceName)
      }

      let results = this.suggestions.inspectPlaceName.filter(item => {
        return item.value.indexOf(queryString) >= 0
      })

      cb(results);
    },
    /**
     * 入力候補探索（通り芯名)
     */
    lineNameSearch(queryString, cb){
      if (this.suggestions.lineName.length == 0) {
        cb()
      }
      if (!queryString) {
        cb(this.suggestions.lineName)
      }
      let results = this.suggestions.lineName.filter(item => {
        return item.value.indexOf(queryString) >= 0
      })

      cb(results);
    },
    /**
     * 入力候補探索（作成者)
     */
    createUserSearch(queryString, cb){
      if (this.suggestions.createUser.length == 0) {
        cb()
      }
      if (!queryString) {
        cb(this.suggestions.createUser)
      }
      let results = this.suggestions.createUser.filter(item => {
        return item.value.indexOf(queryString) >= 0
      })

      cb(results);
    },
    /**
     * アイコン情報を設定します。
     */
    async setIcons() {

      const _this = this
      this.iconUrlList = {};
      this.iconClassNameList = {};

      // 検査マスタループ
      for (let i = 0; i < this.inspectMasters.length; i++) {
        const inspectMaster = this.inspectMasters[i].inspectMaster;
        const masterId = inspectMaster.id;
        const iconSettings = inspectMaster.iconSetting;

        iconSettings.forEach((item) => {
          if (item.iconFilePath) {
              _this.getTenantFile(item.iconFilePath).then(result => {

              // 検査マスタID#アイコンクラス
              const key = `${masterId}#${item.iconClass}`;

              // アイコンURL
              _this.iconUrlList[key] = result;

              // 名称
              _this.iconClassNameList[key] = item.name;

              console.log(`アイコンURL:${_this.iconUrlList[key]}`)
              console.log(`定義名:${_this.iconClassNameList[key]}`)
            })
          }
        })
      }
    },

    /**
     * テナントのファイルURL文字列を取得します。
     *
     * @param {String} s3Key S3キー
     *
     * @returns ファイルURL文字列
     */
    async getTenantFile(s3Key) {

      if (!s3Key) {
        return ""
      }
      try {
        return (await this.tenantStorage.get(s3Key)).toBase64()
        // return await FileUtil.getTenantFileUrl(s3Key)

        // const user = await UserInfo.getUserInfo();
        // const s3KeyPrefix = `tenant/${user.group}/`;
        // console.log(`getTenantFile ${s3KeyPrefix}${s3Key}`);

        // const url = await this.get(`${s3Key}`, {level: "public", customPrefix: {public: s3KeyPrefix}});
        // console.log(`url:: ${url}`);

        // return url.toString();
      } catch (e) {
        // alert(`error getTenantFile ${JSON.stringify(e, null, "\t")}`);
        console.log(`error getTenantFile ${JSON.stringify(e, null, "\t")}`)
        throw e;
      }
    },

    /**
     * S3からURLを取得します。
     *
     * @param {String} key S3キー
     * @param {Object} config 設定情報
     *
     * @returns URL
     */
    async get(key, config) {
      try {
        let imageUrl = await Storage.get(key, config)
        return imageUrl
      } catch (e) {
        this.debugText = `エラー:${JSON.stringify(e)}`
      }
    },

    /**
     * ソートを実行します。
     */
    async runSort(column) {
      await this.changeTableSort(column);
    },

    /**
     * テーブルのソート順を変更します。
     */
    async changeTableSort(column){
      console.log(column);

      if (column === false) {
        return;
      }

      // フィールド名とソート種別を取得
      let fieldName = column.prop;
      let sortingType = column.order;

      console.log(fieldName);

      if (!fieldName) {
        return;
      }

      // 復元用に保持
      // this.sortColumn = column;

      // ソート用フィールドに置き換え
      // if (fieldName == "name") {
      //   fieldName = 'title';
      // } else if (fieldName == "size") {
      //   fieldName = 'sortSize';
      // }

      if (sortingType == "descending"){
        if (fieldName == 'iconClass') {

          this.inspectPlaces = this.inspectPlaces.sort((a, b) => {
            // console.log(a.rebarmeasure[fieldName]);
            if (b.inspectPlace[fieldName] < a.inspectPlace[fieldName]) return -1;
            if (b.inspectPlace[fieldName] > a.inspectPlace[fieldName]) return 1;
          });

        } else {
          // 日本語ソート
          this.inspectPlaces = this.inspectPlaces.sort((a, b) => {
            // console.log(a.rebarmeasure[fieldName]);
            // nullは空文字に置換
            if (!a.inspectPlace[fieldName]) a.inspectPlace[fieldName] = '';
            if (!b.inspectPlace[fieldName]) b.inspectPlace[fieldName] = '';
            a = this.convertKana(a.inspectPlace[fieldName].toString());
            b = this.convertKana(b.inspectPlace[fieldName].toString());
            if (a < b) return 1;
            if (a > b) return -1;
            return 0;
            // return a.localeCompare(b, 'ja');
          })
        }
      }
      else {
        if (fieldName == 'iconClass') {
          this.inspectPlaces = this.inspectPlaces.sort((a, b) => {
            if (b.inspectPlace[fieldName] < a.inspectPlace[fieldName]) return 1;
            if (b.inspectPlace[fieldName] > a.inspectPlace[fieldName]) return -1;
          });
        } else {
          // 日本語ソート
          this.inspectPlaces = this.inspectPlaces.sort((a, b) => {
            // nullは空文字に置換
            if (!a.inspectPlace[fieldName]) a.inspectPlace[fieldName] = '';
            if (!b.inspectPlace[fieldName]) b.inspectPlace[fieldName] = '';
            a = this.convertKana(a.inspectPlace[fieldName].toString());
            b = this.convertKana(b.inspectPlace[fieldName].toString());
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
        }
      }
    },
    // https://gist.github.com/kawanet/5553478
    /** カタカナをひらがなに変換する
     * @param {String} src - カタカナ
     * @returns {String} - ひらがな
     */
    convertKana(src) {
      return src.replace(/[\u30a1-\u30f6]/g, function(match) {
        const chr = match.charCodeAt(0) - 0x60;
        return String.fromCharCode(chr);
      });
    },

    /**
     * マップビューへ遷移します。
     * @param {Object} クリックした検査箇所データ
     */
    onPushMap(row) {
      // ノードID、種別を返す
      row[`nodeId`] = this.nodeId;
      row[`nodeType`] = this.nodeType;

      console.log(JSON.stringify(row, null, "\t"));

      // 地図表示する引数として検査箇所データを指定
      // this.$emit('transfer', {key: "mapArgs", values: row})
      this.$emit('onClickPlaceListItem', row)
    },

    /**
     * 削除クリック処理です。
     */
    async onClickDelete(title) {
      if (!this.selectedData || this.selectedData < 1) {
        return;
      }

      let loader = this.showLoader();

      try {
        await this.deleteSelectedData();
      } catch (e) {
        console.log(`onClickDelete ${e.stack}`)
      } finally {
        this.hideLoader(loader);
      }
    },
    /**
     * 選択した検査箇所データを削除します（論理削除）
     */
    async deleteSelectedData() {
      // console.log(this.selectedData)
      const count = this.selectedData.length;
      let message = "";
      if (count < 1) {
        return;
      } else if (count == 1) {
        message = this.selectedData[0].inspectPlace.name;
      } else if (count > 1) {
        message = `${count}件のデータ`
      }
      const _this = this

      this.confirm.message = `検査箇所を削除します。よろしいですか？`
      this.confirm.leftButtonLabel = "キャンセル"
      this.confirm.rightButtonLabel = "削除"
      this.confirm.leftButtonFn = function() {
        this.showConfirm = false
      }.bind(this)
      this.confirm.rightButtonFn = async function() {
        try {

          for (let i = 0; i < count; i++) {
            let data = this.selectedData[i];
            let skList = data.sk.split("#")
            if (skList.length < 4) {
              return
            }
            let viewModel = new InspectPlaceViewModel(data.pk, skList[1], skList[2], skList[3])
            await viewModel.init()
            await viewModel.deleteInspectPlace()
          }
          this.showConfirm = false

        } catch (e) {
          this.showConfirm = false
          console.log(JSON.stringify(e.stack))
          this.showBottomToast(`削除に失敗しました`, `error`)
          throw e
        }
        this.$emit('inspectPlaceDeleteComplete');
      }.bind(this)
      this.showConfirm = true



      // this.modal = {
      //   isShow: true,
      //   title: "検査箇所の削除",
      //   message: `${message}を削除します。よろしいですか？`,
      //   okLabel: "削除",
      //   okType: "danger",
      //   okCallBack: function() {
      //     try {
      //       for (let i = 0; i < count; i++) {
      //         let data = _this.selectedData[i];

      //         try {
      //           // 削除フラグ
      //           // data.inspectPlace.deleteFlag = true;
      //           // 更新日時
      //           data.timestamp = DateUtil.getUnixTimeStampOfMilliSecond();
      //           console.log(data)

      //           InspectPlaceModel.updateInspectPlace(data);

      //           // this.outputLog(`info`, `deleted ${data.sk}`)

      //         } catch (e) {
      //           console.log(JSON.stringify(e))
      //           // this.outputLog(`error`, `failed delete ${data.sk} : ${e.message}`)

      //           if (e.errors) {
      //             if (e.errors.length > 0) {
      //               switch (e.errors[0].errorType) {
      //               case "DynamoDB:ConditionalCheckFailedException":
      //                 _this.showBottomToast(`他のユーザにて削除されています。`, `warning`)
      //                 // this.outputLog(`warn`, `競合 pk:${this.measureDetailData.pk} sk:${this.measureDetailData.sk}`)
      //                 // リロード
      //                 _this.init();
      //                 break
      //               default:
      //                 // this.outputLog(`error`, `削除に失敗 error:${JSON.stringify(e)} pk:${this.measureDetailData.pk} sk:${this.measureDetailData.sk}`)
      //                 break
      //               }
      //             } else {
      //               _this.showBottomToast(`削除に失敗しました`, `error`)
      //               // this.outputLog(`error`, `削除に失敗 error:${JSON.stringify(e)} pk:${this.measureDetailData.pk} sk:${this.measureDetailData.sk}`)
      //             }

      //           } else {
      //             _this.showBottomToast(`削除に失敗しました`, `error`)
      //             // this.outputLog(`error`, `削除に失敗 error:${JSON.stringify(e)} pk:${this.measureDetailData.pk} sk:${this.measureDetailData.sk}`)
      //           }

      //           throw e
      //         }

      //       }

      //       // 選択状態をクリア
      //       _this.clearSelect();

      //       _this.init();

      //     } catch (e) {
      //       console.log(JSON.stringify(e))
      //       _this.showBottomToast(`データの削除に失敗しました`, `error`)
      //       throw e
      //     }

      //     // 閉じる
      //     _this.modal.isShow = false
      //   },
      //   cancelLabel: "キャンセル",
      //   cancelType: "secondary",
      //   cancelCallBack: function() {
      //     _this.modal.isShow = false
      //   },
      // }
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      return this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },

    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader(loader) {
      loader.hide();
    },
    handleSelect(selection, row) {
      console.log(JSON.stringify(row, null, "\t"))

      if (selection.length > this.maxSelect) {
        this.showBottomToast(`これ以上は選択できません。`, `info`)
        this.$refs.inspectPlaceListTable.toggleRowSelection(row)
        return
      }

    },
    handleSelectionChange(rowDatas) {
      const count = rowDatas.length;
      console.log(`選択件数：${count}`);

      if (count > 1) {
        this.isSingleSelect = false;
        this.isMultiSelect = true;
        this.isExport = true;
      } else if (count == 1) {
        this.isSingleSelect = true;
        this.isMultiSelect = false;
        this.isExport = true;
      } else {
        // 0件
        this.isSingleSelect = false;
        this.isMultiSelect = false;
        this.isExport = false;
      }

      this.selectedData = rowDatas;
    },
    async onClickNewPlace() {

      try {

        // DB登録用データ取得
        let dbData = await InspectPlaceModel.getNewData(this.projectId, this.nodeId);

        const placeId = dbData.sk.split('#')[3];
        console.log('placeId:' + placeId);
        dbData.inspectPlace.placeId = placeId;

        console.log('検査箇所新規登録：' + JSON.stringify(dbData));

        // 検査箇所属性入力へ渡す
        this.$emit('addNewPlace', {newPlaceData: {dbData}});

      } catch (e) {
        // alert(`DB登録失敗 ${e.message}`)
        console.log(JSON.stringify(e))
        throw e
      }

    },
    async onClickOutput() {
      let loader = this.showLoader();
      try {
        console.log('onClickOutput')
        let list = []
        this.selectedData.forEach(item => {
          list.push(item.sk)
        })

        let csvInfo = await CsvInfoModel.getCsv(this.tenantId, list)
        console.log(JSON.stringify(csvInfo))
        if (csvInfo.statusCode == 0) {
          let fileName = path.basename(csvInfo.result)
          let tenantStorage = new TenantStorage(this.tenantId)
          let url = await tenantStorage.get(csvInfo.result, true)
          this.downloadBase(fileName, url)
        } else {
          this.showBottomToast(`CSVファイル作成エラー`, `${csvInfo.result}`)
        }
      } finally {
        this.hideLoader(loader)
        if (this.isCustomized == true) {
          this.clearSelect()
        };
      }

    },
    /**
     * ダウンロードダイアログを表示
     */
    async downloadBase(fileName, url) {
      try {
        // ブラウザにダウンロードダイアログを表示する処理
        const a = document.createElement('a');
        a.href = url
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    /**
     * CSV作成処理のよびだし
     */
    makeForm(){
      let loader = this.showLoader();

      this.hideLoader(loader)
      this.formOutputShow = false

    },
    cancelForm(){
      this.formOutputShow = false
    },
    /**
     * 日付文字を別の形式に変更
     */
    dateStringFormat(dateString) {
      return DateUtil.getFormatString(dateString, "YYYY/MM/DD HH:mm")
    },
    showBottomToast(message, type) {
      this.runToast(message, 'bottom-center', type)
    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    runToast(message, pos, type) {

      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos
      });
    },
    /**
     * カスタマイズレコード追加メソッド
     */
    async addCustomize(){
      //NCS用
      let data = {
        pk: "ncsmanager",
        sk: "customize",
        lsiStr1: "-",
        lsiStr2: "-",
        lsiStr3: "-",
        lsiStr4: "-",
        lsiInt1: 0,
        createdUser: "d93728e1-efd4-41f7-8de4-00b473b56f22",
        updatedUser: "d93728e1-efd4-41f7-8de4-00b473b56f22",
        groups: [
          "ncsmanager"
        ],
        customize: {
          key: "sumigomu",
          memo: "test",
        },
      }
      // 住ゴム様用
      // let data = {
      //   pk: "sumigomu1",
      //   sk: "customize",
      //   lsiStr1: "-",
      //   lsiStr2: "-",
      //   lsiStr3: "-",
      //   lsiStr4: "-",
      //   lsiInt1: 0,
      //   createdUser: "05b9b754-f710-4e56-9dbf-7b29f34adc2c",
      //   updatedUser: "05b9b754-f710-4e56-9dbf-7b29f34adc2c",
      //   groups: [
      //     "ncsmanager",
      //     "sumigomu1"
      //   ],
      //   customize: {
      //     key: "sumigomu",
      //     memo: "test",
      //   },
      // }
        await CustomizeModel.addCustomize(data);
    },


  },
};
</script>
